import { CreateMandateBankaccount } from './mandates/Bankaccount'
import { CreateMandateIBAN } from './mandates/IBAN'
import { CreateMandateNorwegianBankAccount } from './mandates/NorwegianBankAccount'
import { CreateMandateOverforselsService } from './mandates/OverforselsService'
import { Unknown } from './mandates/Unknown'

export const CreateMandate = Object.freeze({
  SE: CreateMandateBankaccount,
  FI: CreateMandateIBAN,
  DK: CreateMandateOverforselsService,
  NO: CreateMandateNorwegianBankAccount,
  UNKNOWN: Unknown,
})
